import React from "react";
import YouTube from "react-youtube";

class VideYoutube extends React.Component {
  render() {
    const opts = {
      height: "390",
      width: "640",
      playerVars: {
        autoplay: 0
      }
    };

    return (
      <section id="video" className="py-3">
        <div className="container p-5 d-none d-md-block">
          <div className="row m-3 justify-content-center">
              <YouTube
                videoId="LQXnVfecBOQ"
                opts={opts}
                onReady={this._onReady}
              />
          </div>
        </div>
      </section>
    );
  }

  _onReady(event) {
    event.target.pauseVideo();
  }
}

export default VideYoutube;



// WEBPACK FOOTER //
// ./src/components/Cloackroom/VideoYoutube/VideoYoutube.js